const turfLength = require('@turf/length').default;
const numeral = require('numeral');

function getDisplayMeasurements(feature) {
  // Calculate length in kilometers using Turf.js
  const drawnLength = turfLength(feature) * 1000; // meters

  // Metric system
  let metricUnits = 'm';
  let metricFormat = '0,0';
  let metricMeasurement;

  // Standard (imperial) system
  let standardUnits = 'ft';
  let standardFormat = '0,0';
  let standardMeasurement;

  // Nautical miles
  let nauticalUnits = 'NM';
  let nauticalFormat = '0.00';
  let nauticalMeasurement;

  // Metric calculations
  metricMeasurement = drawnLength;
  if (drawnLength >= 1000) {
    // If over 1000 meters, convert to kilometers
    metricMeasurement = drawnLength / 1000;
    metricUnits = 'km';
    metricFormat = '0.00';
  }

  // Standard calculations
  standardMeasurement = drawnLength * 3.28084; // Convert meters to feet
  if (standardMeasurement >= 5280) {
    // If over 5280 feet, convert to miles
    standardMeasurement /= 5280;
    standardUnits = 'mi';
    standardFormat = '0.00';
  }

  // Nautical miles calculation
  nauticalMeasurement = drawnLength / 1852; // 1 NM = 1852 meters

  // Create display measurements object
  const displayMeasurements = {
    metric: `${numeral(metricMeasurement).format(metricFormat)} ${metricUnits}`,
    standard: `${numeral(standardMeasurement).format(
      standardFormat
    )} ${standardUnits}`,
    nautical: `${numeral(nauticalMeasurement).format(
      nauticalFormat
    )} ${nauticalUnits}`
  };

  return displayMeasurements;
}

module.exports = {
  getDisplayMeasurements
};